import { render, staticRenderFns } from "./TrackingTag.vue?vue&type=template&id=4f57077b&lang=pug"
import script from "./TrackingTag.vue?vue&type=script&lang=js"
export * from "./TrackingTag.vue?vue&type=script&lang=js"
import style0 from "./TrackingTag.vue?vue&type=style&index=0&id=4f57077b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports